import Vue from 'vue'
import openDataConstant from '@/modules/base/config/openDataConstant'
Vue.prototype.$openDataConstant = openDataConstant


export default {
  onAppLaunch(vm) {
    const inspectUnits = [
      '新聞暨節目自律委員會',
      '新聞評量委員會',
      '客家電視台諮議委員會',
      '製播準則',
      '公共問責',
    ]
    Vue.prototype.$inspectUnits = inspectUnits.map(unit => vm.$helper.changeText(unit))

    /**
     * 取得當日白天通過的參訪
     * @param events 參訪資料陣列
     * @returns {number}
     */
    vm.$helper.getVisitMorningEventsQuantity = (events) => {
      if(!Array.isArray(events)) return 0
      return events.filter(event => {
        if(event.time_period != vm.$MEMBER_CONSTANTS.VISIT_TIME_PERIOD_MORNING) return false
        if(event.status != vm.$MEMBER_CONSTANTS.VISIT_STATUS_APPLY) return false
        return true
      }).length
    }

    /**
     * 下午確定的參訪數量
     * @param events 參訪資料陣列
     * @returns {number}
     */
    vm.$helper.getVisitAfternoonEventsQuantity = (events) => {
      if(!Array.isArray(events)) return 0
      return events.filter(event => {
        if(event.time_period != vm.$MEMBER_CONSTANTS.VISIT_TIME_PERIOD_AFTERNOON) return false
        if(event.status != vm.$MEMBER_CONSTANTS.VISIT_STATUS_APPLY) return false
        return true
      }).length
    }

    /**
     * 判斷該時段設定選項是否需要disabled
     * @param period radio button的時段選項(參考: $MEMBER_CONSTANTS的VISIT_TIME_PERIOD系列)
     * @param options
     * @returns {boolean}
     */
    vm.$helper.periodDisabled = (period, options = {}) => {
      const {
        morningEventsQuantity, // 白天申請成功的參訪數量
        afternoonEventsQuantity, // 下午申請成功的參訪數量
      } = options

      // 批次編輯popup使用
      if(period == null) {
        period = vm.$MEMBER_CONSTANTS.VISIT_TIME_PERIOD_ALL_DAY
      }

      // 全天: 不限制
      if(period == vm.$MEMBER_CONSTANTS.VISIT_TIME_PERIOD_ALL_DAY) {
        return false
      }

      // 白天: 有申請成功的參訪就disabled
      if(period == vm.$MEMBER_CONSTANTS.VISIT_TIME_PERIOD_MORNING) {
        return afternoonEventsQuantity > 0
      }

      // 下午: 天有申請成功的參訪就disabled
      if(period == vm.$MEMBER_CONSTANTS.VISIT_TIME_PERIOD_AFTERNOON) {
        return morningEventsQuantity > 0
      }

      // 全天禁止: 白天或下午有一個申請成功的參訪就disabled
      if(morningEventsQuantity > 0) return true
      if(afternoonEventsQuantity > 0) return true
      return false
    }
  },
}